export const environment = {
  name: 'dev',
  production: false,
  configFile: 'assets/config/config.qa.json'
};
